export { default } from './ManagedAccountActivitySummaryChart';
